export const CustomerAgreementNameMaxLength = 200;

export function readName(value: unknown): string {
    return typeof value === 'string' ? value.trim() : '';
}

export function isValidCustomerAgreementName(name: string): boolean {
    const trimmedName = name.trim();

    return trimmedName !== '' && trimmedName.length <= CustomerAgreementNameMaxLength;
}
